import React from "react";
import _ from "lodash";
import { Link } from "react-router-dom";

import "../styles/components/CarAvatar.css";

import arrowIcon from "../assets/images/icons/svg/arrow-small-orange.svg";
import availableNowWhite from "../assets/icons-main/available-now.png";

const CarAvatar = ({ carData }) => {
  const {
    acceleration,
    bodyType,
    drive,
    engineCapacity,
    enginePower,
    engineType,
    gearType,
    year
  } = carData.acf.parameters;
  const availableNow = _.get(
    carData,
    "acf.availableNow.availableNowCheckbox",
    false
  );
  return (
    <div
      className={`car-avatar ${carData.acf.prices.rentFromPrice
        .rentFromPriceValue && "from-price"}`}
      style={{ backgroundImage: `url(${carData.acf.vehicleAvatar})` }}
    >
      <Link to={`/flota/${carData.slug}`}>
        <div className="car-avatar-desc car-avatar-desc--main">
          <span className="car-manufacture">
            {carData.title.rendered.split(" ")[0]}
          </span>
          <span className="large">
            {carData.title.rendered
              .split(" ")
              .slice(1)
              .join(" ")}
            <img className="svg" src={arrowIcon} alt="Question icon arrow" />
          </span>
        </div>
        <div className="car-avatar-desc car-avatar-desc--parameters">
          {availableNow && (
            <span
              style={{
                color: "#ff5000",
                marginBottom: "10px",
                fontWeight: "600"
              }}
            >
              Dostępny od ręki!
            </span>
          )}
          <span className="car-year">{year}</span>
          <span className="car-engineCapacity">{engineCapacity}</span>
          <span className="car-power">
            {enginePower}
            km
          </span>
          <span className="car-power">{acceleration}s</span>
          <span className="car-engineType">{engineType.name}</span>
          <span className="car-gear">{gearType.name}</span>
          <span className="car-drive">{drive.name}</span>
          <span className="car-type">{bodyType.name}</span>
        </div>
        {carData.acf.prices.rentFromPrice.rentFromPriceType &&
          carData.acf.prices.rentFromPrice.rentFromPriceValue && (
            <p className="car-avatar--from-price">
              {carData.acf.prices.rentFromPrice.rentFromPriceType === "rent" &&
                `Wynajem już od ${
                  carData.acf.prices.rentFromPrice.rentFromPriceValue
                } zł!`}
              {carData.acf.prices.rentFromPrice.rentFromPriceType === "sell" &&
                `Sprzedaż już od ${parseInt(
                  carData.acf.prices.rentFromPrice.rentFromPriceValue
                ) / 1000}tys zł!`}
              {availableNow && (
                <img src={availableNowWhite} alt="Available now icon" />
              )}
            </p>
          )}
      </Link>
    </div>
  );
};

export default CarAvatar;
